import React from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useSelector } from 'react-redux';
import BackButton from '../../../components/BackButton';
import { Helmet } from 'react-helmet';

function CreateEmployee() {
    const navigate = useNavigate();
    const form = useForm();
    const { token } = useSelector((state) => state.auth)
    const saveEmployee = (data) => {
        console.log(data)
        axios.post(`${process.env.REACT_APP_SERVICE_URL}/employees`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                form.reset()
                navigate(-1)
            })
            .catch((error) => {
                console.error(error)
            })

    }
    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Yeni Çalışan</title>
                <meta name='description' content='Yeni çalışan ekleme formu' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title="Yeni Çalışan" description="Yeni çalışan ekleme formu" />

            <div className='row'>
                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />
                            <form className='mt-3' onSubmit={form.handleSubmit(saveEmployee)}>
                                <div className='mb-3'>
                                    <label htmlFor='firstName' className='form-label'>Adı</label>
                                    <input type='text' className='form-control' id='firstName' {...form.register('firstName')} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='lastName' className='form-label'>Soyadı</label>
                                    <input type='text' className='form-control' id='lastName' {...form.register('lastName')} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='phoneNumber' className='form-label'>Telefon</label>
                                    <input type='text' className='form-control' id='phoneNumber' {...form.register('phoneNumber')} />
                                </div>
                                <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateEmployee